<template>
  <el-table-column
    prop="customer_country"
    sortable="custom"
    label="Ország"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      <span>{{ scope.row.customer_country }}</span>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'customer_address.country.name',
};
</script>
